import C from '@/config/index'
/**
 * 数据处理
 * @author gs089597@163.com
 * @version 1.0.0
 **/
let dateUtils = {
    UNITS: {
        '年': 31557600000,
        '月': 2629800000,
        '天': 86400000,
        '小时': 3600000,
        '分钟': 60000,
        '秒': 1000
    },
    humanize: function(milliseconds) {
        let humanize = ''
        for (let key in this.UNITS) {
            if (milliseconds >= this.UNITS[key]) {
                humanize = Math.floor(milliseconds / this.UNITS[key]) + key + '前'
                break
            }
        }
        return humanize || '刚刚'
    },
    format: function(dateStr) {
        let date = this.parse(dateStr)
        let diff = Date.now() - date.getTime()
        if (diff < this.UNITS['天'] * 5) {
            return this.humanize(diff)
        }
        return dateStr
    },
    parse: function(str) { // 将"yyyy-mm-dd HH:MM:ss"格式的字符串，转化为一个Date对象
        let a = str.split(/[^0-9]/)
        return new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5])
    }
}
const utils = {
    // 去空格
    trim: function(value) {
        return value.replace(/(^\s*)|(\s*$)/g, '')
    },
    // 内容替换
    replaceAll: function(text, repstr, newstr) {
        return text.replace(new RegExp(repstr, 'gm'), newstr)
    },
    // 格式化手机号码
    formatNumber: function(num) {
        return num.length === 11 ? num.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') : num
    },
    // 金额格式化
    rmoney: function(money) {
        return parseFloat(money).toFixed(2).toString().split('').reverse().join('').replace(/(\d{3})/g, '$1,').replace(
            /\,$/, '').split('').reverse().join('')
    },
    rgbToHex: function(r, g, b) {
        return '#' + utils.toHex(r) + utils.toHex(g) + utils.toHex(b)
    },
    toHex: function(n) {
        n = parseInt(n, 10)
        if (isNaN(n)) return '00'
        n = Math.max(0, Math.min(n, 255))
        return '0123456789ABCDEF'.charAt((n - n % 16) / 16) +
            '0123456789ABCDEF'.charAt(n % 16)
    },
    hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null
    },
    formatDate(format, timestamp) {
        let jsdate = ((timestamp) ? new Date(timestamp * 1000) : new Date())
        let pad = function(n, c) {
            if ((n = n + '').length < c) {
                return new Array(++c - n.length).join('0') + n
            } else {
                return n
            }
        }
        let txt_weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        let txt_ordin = { 1: 'st', 2: 'nd', 3: 'rd', 21: 'st', 22: 'nd', 23: 'rd', 31: 'st' }
        let txt_months = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        let f = {
            d: function() {
                return pad(f.j(), 2)
            },
            D: function() {
                return f.l().substr(0, 3)
            },
            j: function() {
                return jsdate.getDate()
            },
            l: function() {
                return txt_weekdays[f.w()]
            },
            N: function() {
                return f.w() + 1
            },
            S: function() {
                return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'
            },
            w: function() {
                return jsdate.getDay()
            },
            z: function() {
                return (jsdate - new Date(jsdate.getFullYear() + '/1/1')) / 864e5 >> 0
            },
            W: function() {
                let a = f.z()
                let b = 364 + f.L() - a
                let nd2
                let nd = (new Date(jsdate.getFullYear() + '/1/1').getDay() || 7) - 1
                if (b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b) {
                    return 1
                } else {
                    if (a <= 2 && nd >= 4 && a >= (6 - nd)) {
                        nd2 = new Date(jsdate.getFullYear() - 1 + '/12/31')
                        return new Date('W', Math.round(nd2.getTime() / 1000))
                    } else {
                        return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0)
                    }
                }
            },
            F: function() {
                return txt_months[f.n()]
            },
            m: function() {
                return pad(f.n(), 2)
            },
            M: function() {
                return f.F().substr(0, 3)
            },
            n: function() {
                return jsdate.getMonth() + 1
            },
            t: function() {
                let n
                if ((n = jsdate.getMonth() + 1) === 2) {
                    return 28 + f.L()
                } else {
                    if (n & 1 && n < 8 || !(n & 1) && n > 7) {
                        return 31
                    } else {
                        return 30
                    }
                }
            },
            L: function() {
                let y = f.Y()
                return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0
            },
            Y: function() {
                return jsdate.getFullYear()
            },
            y: function() {
                return (jsdate.getFullYear() + '').slice(2)
            },
            a: function() {
                return jsdate.getHours() > 11 ? 'pm' : 'am'
            },
            A: function() {
                return f.a().toUpperCase()
            },
            B: function() {
                // peter paul koch:
                let off = (jsdate.getTimezoneOffset() + 60) * 60
                let theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off
                let beat = Math.floor(theSeconds / 86.4)
                if (beat > 1000) beat -= 1000
                if (beat < 0) beat += 1000
                if ((String(beat)).length === 1) beat = '00' + beat
                if ((String(beat)).length === 2) beat = '0' + beat
                return beat
            },
            g: function() {
                return jsdate.getHours() % 12 || 12
            },
            G: function() {
                return jsdate.getHours()
            },
            h: function() {
                return pad(f.g(), 2)
            },
            H: function() {
                return pad(jsdate.getHours(), 2)
            },
            i: function() {
                return pad(jsdate.getMinutes(), 2)
            },
            s: function() {
                return pad(jsdate.getSeconds(), 2)
            },
            O: function() {
                let t = pad(Math.abs(jsdate.getTimezoneOffset() / 60 * 100), 4)
                jsdate.getTimezoneOffset() > 0 ? t = '-' + t : t = '+' + t
                return t
            },
            P: function() {
                let O = f.O()
                return (O.substr(0, 3) + ':' + O.substr(3, 2))
            },
            c: function() {
                return f.Y() + '-' + f.m() + '-' + f.d() + 'T' + f.h() + ':' + f.i() + ':' + f.s() + f.P()
            },
            U: function() {
                return Math.round(jsdate.getTime() / 1000)
            }
        }

        return format.replace(/[]?([a-zA-Z])/g, function(t, s) {
            let ret
            if (t !== s) {
                ret = s
            } else if (f[s]) {
                ret = f[s]()
            } else {
                ret = s
            }
            return ret
        })
    },

    /*
     * 截断字符串
     * @param str 传入字符串
     * @param len 截断长度
     * @param hasDot 末尾是否...
     * @returns {String}
     */
    truncateString(str, len, hasDot = true) {
        let newLength = 0
        let newStr = ''
        let singleChar = ''
        const chineseRegex = /[^\x00-\xff]/g
        const strLength = str.replace(chineseRegex, '**').length
        for (let i = 0; i < strLength; i++) {
            singleChar = str.charAt(i).toString()
            if (singleChar.match(chineseRegex) !== null) {
                newLength += 2
            } else {
                newLength++
            }
            if (newLength > len) {
                break
            }
            newStr += singleChar
        }

        if (hasDot && strLength > len) {
            newStr += '...'
        }
        return newStr
    },

    // 获取随机字符串
    randomString(len) {
        len = len || 32
        let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
        let maxPos = $chars.length
        let pwd = ''
        for (let i = 0; i < len; i++) {
            pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
        }
        return pwd
    },

    // 所有参数按字典排序
    sortDict(dict) {
        let dict2 = {}
        let keys = Object.keys(dict).sort()
        for (let i = 0, n = keys.length, key; i < n; ++i) {
            key = keys[i]
            dict2[key] = dict[key]
        }
        return dict2
    },

    // url拼接
    urlEncode(param, key) {
        if (param == null) return ''
        let paramStr = ''
        let t = typeof (param)
        if (t === 'string' || t === 'number' || t === 'boolean') {
            paramStr += '&' + key + '=' + param
        } else {
            for (let i in param) {
                let k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
                paramStr += utils.urlEncode(param[i], k)
            }
        }
        return paramStr
    },
    getImgUrl(url) {
        if (!url) return null
        if (url && (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1)) {
            return url
        } else {
            return C.Host + url
        }
    },
    /*
    * 数组分隔为二维分组
    * */
    splitArray(arr, len) {
        let aLen = arr.length
        let result = []
        for (let i = 0; i < aLen; i++) {
            arr[i].index = i
        }
        for (let i = 0; i < aLen; i += len) {
            result.push(arr.slice(i, i + len))
        }
        return result
    },
    colorToHex(color) {
        let values = color
            .replace(/rgba?\(/, '')
            .replace(/\)/, '')
            .replace(/[\s+]/g, '')
            .split(',')
        let a = parseFloat(values[3] || 1)
        let r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255)
        let g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255)
        let b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255)
        return '#' +
            ('0' + r.toString(16)).slice(-2) +
            ('0' + g.toString(16)).slice(-2) +
            ('0' + b.toString(16)).slice(-2)
    },
    isAndroid() {
        let u = navigator.userAgent
        return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    }
}

export default {
    trim: utils.trim,
    replaceAll: utils.replaceAll,
    formatNumber: utils.formatNumber,
    rmoney: utils.rmoney,
    formatDate: utils.formatDate,
    rgbToHex: utils.rgbToHex,
    hexToRgb: utils.hexToRgb,
    truncateString: utils.truncateString,
    randomString: utils.randomString,
    sortDict: utils.sortDict,
    urlEncode: utils.urlEncode,
    getImgUrl: utils.getImgUrl,
    splitArray: utils.splitArray,
    colorToHex: utils.colorToHex,
    dateUtils
}
